import ApiService from '@/core/services/api.service';

const BASE_URL = 'pre-orders';

const PreorderService = {
  getAll(params = {}) {
    return ApiService.query(BASE_URL, { params });
  },

  getById(id) {
    return ApiService.query(`${BASE_URL}/${id}`);
  },

  create(data) {
    return ApiService.post(BASE_URL, data);
  },

  update(id, data) {
    return ApiService.put(`${BASE_URL}/${id}`, data);
  },

  convert(id, data = {}) {
    return ApiService.post(`${BASE_URL}/${id}/convert`, data);
  },

  exportExcel(params = {}) {
    return ApiService.query(`${BASE_URL}/export`, {
      params,
      responseType: 'blob',
    });
  },

  uploadImage(formData) {
    return ApiService.post(`${BASE_URL}/upload-image`, formData);
  },

  async fetchPreviewImage(storedPath, entityId = null) {
    if (!storedPath || typeof storedPath !== 'string') return '';
    if (storedPath.startsWith('http://') || storedPath.startsWith('https://'))
      return storedPath;
    const params = { path: storedPath };
    if (entityId != null && entityId !== '') params.entityId = entityId;
    const res = await ApiService.query(`${BASE_URL}/preview-image`, {
      params,
      responseType: 'blob',
    });
    const blob = res?.data ?? res;
    return blob ? URL.createObjectURL(blob) : '';
  },
};

export default PreorderService;
